export const styles = {
  text: {
    display: "flex",
    justifyContent: "center",
    fontSize: "8pt",
    color: "#aaa"
  }
};
